export interface ControlLockMode {
  id: string;
  deviceId: string;
  note: string;
  updatedBy: string;
  mode: string;
  createdAt: string;
}

export enum ControlLockModeEnum {
  LOCKED = 'locked',
  UNLOCKED = 'unlocked',
}
